import React from 'react';
import { Box, Container, Typography, Link, Divider } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <Box component="footer" sx={{ 
      bgcolor: 'background.paper', 
      py: 3,
      mt: 'auto'
    }}>
      <Divider />
      <Container maxWidth="lg">
        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center',
          py: 2
        }}>
          <Typography variant="body2" color="text.secondary">
            © {currentYear} XperienceTattoo. {t('footer.allRightsReserved')}
          </Typography>
          
          <Box sx={{ 
            display: 'flex', 
            gap: 3,
            mt: { xs: 2, sm: 0 },
            flexWrap: 'wrap',
            justifyContent: 'center'
          }}>
            <Link component={RouterLink} to="/privacy-policy" color="inherit" variant="body2">
              {t('footer.privacyPolicy')}
            </Link>
            <Link component={RouterLink} to="/legal-advise" color="inherit" variant="body2">
              {t('footer.legalAdvise')}
            </Link>
            <Link component={RouterLink} to="/cookies-policy" color="inherit" variant="body2">
              {t('footer.cookiesPolicy')}
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 